import { render, staticRenderFns } from "./ExclamationTriangle.vue?vue&type=template&id=01d62120&"
import script from "./ExclamationTriangle.vue?vue&type=script&lang=js&"
export * from "./ExclamationTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d62120')) {
      api.createRecord('01d62120', component.options)
    } else {
      api.reload('01d62120', component.options)
    }
    module.hot.accept("./ExclamationTriangle.vue?vue&type=template&id=01d62120&", function () {
      api.rerender('01d62120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ExclamationTriangle.vue"
export default component.exports